const base = {
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    round: '50%',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  transitions: {
    fast: '120ms cubic-bezier(0.16,1,0.3,1)',
    medium: '200ms cubic-bezier(0.16,1,0.3,1)',
    slow: '400ms cubic-bezier(0.16,1,0.3,1)',
  },
  fonts: {
    sans: "'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif",
    display: "'Fraunces', 'Times New Roman', Georgia, serif",
    mono: "'DM Mono', 'SF Mono', Menlo, Consolas, monospace",
  },
};

export const darkTheme = {
  ...base,
  colors: {
    primary: '#ECE8E0',
    accent: '#FF5B3A',
    bg: '#0E0E10',
    surface: '#16161A',
    paper: '#ECE8E0',
    italicAccent: '#FF8A6B',
    background: {
      primary: '#0E0E10',
      secondary: '#16161A',
    },
    text: {
      primary: '#ECE8E0',
      secondary: 'rgba(236,232,224,0.72)',
      muted: 'rgba(236,232,224,0.5)',
    },
    textRgb: '236,232,224',
    bgRgb: '14,14,16',
    border: 'rgba(236,232,224,0.14)',
    borderStrong: 'rgba(236,232,224,0.28)',
  },
  shadows: {
    small: '0 1px 2px rgba(0,0,0,0.3)',
    medium: '0 4px 16px rgba(0,0,0,0.4)',
    large: '0 16px 48px rgba(0,0,0,0.5)',
  },
};

export const lightTheme = {
  ...base,
  colors: {
    primary: '#0E0E10',
    accent: '#FF5B3A',
    bg: '#FFFFFF',
    surface: '#F2F2F2',
    paper: '#0E0E10',
    italicAccent: '#FF8A6B',
    background: {
      primary: '#FFFFFF',
      secondary: '#F2F2F2',
    },
    text: {
      primary: '#0E0E10',
      secondary: 'rgba(14,14,16,0.72)',
      muted: 'rgba(14,14,16,0.5)',
    },
    textRgb: '14,14,16',
    bgRgb: '255,255,255',
    border: 'rgba(14,14,16,0.12)',
    borderStrong: 'rgba(14,14,16,0.24)',
  },
  shadows: {
    small: '0 1px 2px rgba(0,0,0,0.08)',
    medium: '0 4px 16px rgba(0,0,0,0.12)',
    large: '0 16px 48px rgba(0,0,0,0.16)',
  },
};

export const theme = darkTheme;
